import dataGet from '@/utils/dataGet'
import cache from '@/utils/cache'

export async function getData(model = {}) {
  let value = []
  let key = model.key
  let requestParam = model.requestParam
  let dataType = model.dataType
  let method = model.method || 'post'
  let dg = new dataGet(key, dataType, requestParam, method)
  //localの場合
  if (dataType == 'local') {
    return await dg.getData()
  }
  if (model.enableCache) {
    value = cache.session.getJSON(key)
  }
  if (!value || value.length == 0) {
    const list = await dg.getData()
    if (list) {
      value = list
      if (model.enableCache) {
        cache.session.setJSON(key, value)
      }
    }
  }
  return value
}
